function normalizeTemplate(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const rawId = raw.id != null ? String(raw.id).trim() : '';
  const id = rawId || '';
  const paymentTypeRaw = String(raw.paymentType || raw.payment_type || '').toLowerCase();
  const paymentType = paymentTypeRaw === 'individual' ? 'individual' : 'mass';
  const reconciliation = String(raw.reconciliation || raw.reconciliation_type || raw.strat || '').toUpperCase();
  return {
    id,
    n: String(raw.name || raw.n || '').trim(),
    description: String(raw.description || ''),
    paymentType,
    fileType: String(raw.fileType || raw.file_type || '').toUpperCase() === 'TXT' ? 'TXT' : 'CSV',
    sep: raw.sep === ',' || raw.delimiter === ',' ? ',' : ';',
    strat: reconciliation === 'BY_CNPJ' ? 'BY_CNPJ' : 'BY_CPF',
    identifierFieldMode: (raw.identifierFieldMode || raw.identifier_field_mode) === 'COLUMN_POSITION' ? 'COLUMN_POSITION' : 'COLUMN_NAME',
    identifierFieldLocation: String(raw.identifierFieldLocation || raw.identifier_field_location || ''),
    allowedUsers: Array.isArray(raw.allowedUsers)
      ? raw.allowedUsers.map((x) => String(x))
      : Array.isArray(raw.allowed_users)
        ? raw.allowed_users.map((x) => String(x))
        : [],
    cols: Number.isFinite(Number(raw.cols)) ? Number(raw.cols) : 0,
    conta: String(raw.conta || '-'),
    tipo: paymentType === 'individual' ? 'Individual' : 'Em massa',
    ativo: raw.ativo !== false && raw.active !== false,
  };
}

export {
  normalizeTemplate,
};
